import axios from 'axios';
import RestService from '../../helpers/RestService';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getQuestions() {
  try {
    const {data} = await axios.get('/feedback/mylist');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getMessages(id) {
  try {
    const {data} = await axios.get('/feedback/messages?id=' + id);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}



export async function createAnswer(body) {
  try {
    const {data} = await axios.post('/feedback/createanswer2', {data: JSON.stringify(body)});
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Support/actions.js